app.service('ajaxOrder', function (broker, console, loading, modal) {
	function setForm($form) {
		$form.ajaxForm({
			beforeSubmit: function(){
				loading.start();
			},
			success: function (html) {
				success({
					html: html,
					scroll: '#shop-delivery .row-delivery-point, #home-delivery  .row-delivery-point, form'
				});
				
			}, error: function () {
				error();
			}
		});
	}
	function init(){

	}
	function success(params){
		console.log('AJAXORDER SUCCESS', params);
		let $target = $('body > .page');
		params.oldUrl = $('meta[name="nice"]').attr('value');
		let $newHtml = $('<div>' + params.html + '</div>');
		let newUrl = $newHtml.find('meta[name="nice"]').attr('value');
		let newCsrfContent = $newHtml.find('meta[name="_csrf"]').attr('content');
		let newTitle = $newHtml.find('title').text();
		let $newPage = $newHtml.find('.page');
		let result = $newPage.html();
		let newId = $newPage.attr('id');
		let newClass = $newPage.attr('class');
		params.newTitle = newTitle;
		params.newUrl = newUrl;
		params.newId = newId;
		params.newClass = newClass;
		params.token = newCsrfContent;
		modal.removeRemodals();
		broker.trigger('BEFORE_PAGE_CHANGE');
		$target.html(result);
		UA.pageview();
		$('head title').text(newTitle);
		if(newCsrfContent && newCsrfContent.length){
			let newCsrfHeader = $newHtml.find('meta[name="_csrf_header"]').attr('content');
			let $newCsrf = $('head meta[name="_csrf"]');
			if($newCsrf.length){
				$newCsrf.attr('content', newCsrfContent);
			}else{
				let $newCsrfContent = $('<meta name="_csrf"/>');
				$newCsrfContent.attr('content', newCsrfContent);
				let $newCsrfHeader = $('<meta name="_csrf_header"/>');
				$newCsrfHeader.attr('content', newCsrfHeader);
				$('head').append($newCsrfContent).append($newCsrfHeader);
			}
		}
		
		$target.attr({
			id: newId,
			class: newClass
		});
		if(!params.back){
			history.pushState(params, "", newUrl);
		}
		loading.stop();
		broker.trigger('PAGE_CHANGE');
		if(params.scroll){
			let $scroll = $(params.scroll).first();
			if($scroll.length){
				console.log('PRZESUNIĘCIE STRONY DO: '+params.scroll, $scroll);
				$.scrollTo($scroll, 300);
			} else {
				console.log('PRZESUNIĘCIE NA GÓRĘ STRONY');
				$.scrollTo($('article'), 300);
			}
		}
		if(params.click){
			let $click = $(params.click);
			if($click.length){
				console.log('KLIKNIĘCIE ELEMENTU: '+params.click, $click);
				$click.first().trigger('click');
			}
		}
		broker.trigger('AFTER_PAGE_CHANGE');
	}
	function error(){
		modal.alert('Załadowanie strony okazało się niemożliwe. Strona zostanie przeładowana. Spróbuj ponownie', function(){
			loading.reload();
		});
	}
	function reload(){
		get({
			href: location.pathname
		});
	}
	function get(params){
		if(params && params.href){
			loading.start();
			console.log('ŁADOWANIE STRONY: '+params.href);
			$.ajax({
				url: params.href,
				success: function(html){
					params.html = html;
					success(params);
				},
				error: function(){
					error();
				}
			});
		}
	}
	function back(e){
		console.log(e);
		var href = e && e.state && e.state.url ? e.state.url : location.pathname
		get({
			href: href,
			back: true
		});
	}
	window.onpopstate = back;
	return {
		init, get, setForm, reload
	};
});